module.exports = __webpack_public_path__ + "img/certop.7f13e834.png";